import jsonToFormData from "json-form-data"

const abortErrors = ['AbortError', 'NetworkError', 'TypeError', 'aborting previous request']

class ApiService {
    controller = undefined;
    constructor() {}

    async get(url, data = {}, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let requestOptions = {
            method: "GET"
        }
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url + '?' + new URLSearchParams(data),
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json
        }).catch((error) => {
            console.error("Error fetching data:", error);
            if (abortErrors.includes(error)) {
                console.log('Fetch aborted');
            } else {
                // Handle other errors
                console.error('Fetch error:', error);
            }
            return {error: true, message: error};
        })
    }

    async post(url, data = null, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let requestOptions = {
            method: "POST",
            body: JSON.stringify(data)
        }
        
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url, 
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json;
        }).catch((error) => {
            console.error("Error fetching data:", error);
            if (abortErrors.includes(error)) {
                console.log('Fetch aborted');
            } else {
                // Handle other errors
                console.error('Fetch error:', error);
            }
            return {error: true, message: error};
        })
    }

    async postFormData(url, data = {}, allowAbort = true) {
        const headers = {
            'Accept': 'application/json',
            // 'Content-Type': 'multipart/form-data'
        }
        let formData = jsonToFormData(data)

        let requestOptions = {
            method: "POST",
            body: formData
        }
        
        if (allowAbort) {
            this.controller?.abort("aborting previous request");
            this.controller = new AbortController();
            requestOptions = {
                headers,
                signal: this.controller.signal,
                ...requestOptions
            }
        } else {
            requestOptions = {
                headers,
                ...requestOptions
            }
        }

        return fetch(url, 
            requestOptions
        ).then((response) =>
            response.json()
        ).then( (json) => {
            console.log("result", json);
            this.controller = undefined;
            return json;
        }).catch((error) => {
            console.error("Error fetching data:", error);
            if (abortErrors.includes(error)) {
                console.log('Fetch aborted');
            } else {
                // Handle other errors
                console.error('Fetch error:', error);
            }
            return {error: true, message: error};
        })
    }
}
const apiService = new ApiService();
export default apiService;

